module.exports = __webpack_public_path__ + "img/icon-02-subscriptionAsset 8.7e43fb02.svg";